import { createAction, props } from '@ngrx/store';

import { ISite } from '@shared/types';

export const UPDATE_SITE_SELECTION = 'UPDATE_SITE_SELECTION';
export const UPDATE_SITE_SELECTION_SUCCESS = 'UPDATE_SITE_SELECTION_SUCCESS';
export const UPDATE_SITE_SELECTION_FAILURE = 'UPDATE_SITE_SELECTION_FAILURE';

const REDUCER_KEY = '[CONFIGURABLE_SITES_REDUCER]';

const buildReducerType = (action: string) => `${REDUCER_KEY} ${action}`;

export const update_site_selection = createAction(
    buildReducerType(UPDATE_SITE_SELECTION),
    props<{
        compKey: string;
        value: {
            sites: Array<ISite>;
            isMultiple: boolean;
        };
    }>(),
);
export const update_site_selection_success = createAction(
    buildReducerType(UPDATE_SITE_SELECTION_SUCCESS),
    props<{
        compKey: string;
        value: {
            sites: Array<ISite>;
            isMultiple: boolean;
        };
    }>(),
);
export const update_site_selection_failure = createAction(buildReducerType(UPDATE_SITE_SELECTION_FAILURE));
